import { intersectTwo } from "./../../../../Dispatch/utils/utils";
import {
  DELIVERY_ACCESSORIALS,
  PICKUP_ACCESSORIALS,
} from "./../../../RouteExecution/constants";
import { getTimeDifferenceInMinutes } from "../../../../Reports/NextStopCompliance/NextStopComplianceUtills";

const pluralize = (count, noun, suffix = "s") =>
  `${count} ${noun}${count > 1 ? suffix : ""}`;

const getMinutesInHourAndMinutesStr = (totalMinutes, useExactMatch = false) => {
  if (useExactMatch && totalMinutes === 60) {
    return '60 mins';
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) {
    return `${pluralize(hours, "hour")} ${pluralize(minutes, "min")}`;
  }
  return pluralize(minutes, "min");
};

const getAccessorialsAfterExclusion = ({
  selectedAccessorials,
  accessorialExclusionList,
  isLiftgateTrailer = false,
}) => {
  let appliedAccessorialsList = [...selectedAccessorials];
  selectedAccessorials.forEach((accessorialCode) => {
    const accesorialInExclusionObj = accessorialExclusionList?.find(
      (accessorial) => accessorial.code === accessorialCode
    );
    if (accesorialInExclusionObj) {
      accesorialInExclusionObj.exclusionCodes?.forEach((exclusionCodeList) => {
        if (
          intersectTwo(exclusionCodeList, selectedAccessorials).length ===
          exclusionCodeList.length
        ) {
          appliedAccessorialsList = appliedAccessorialsList.filter(
            (appliedAccessorialCode) =>
              !exclusionCodeList.includes(appliedAccessorialCode)
          );
        }
      });
    }
  });
  if (!isLiftgateTrailer) {
    if (appliedAccessorialsList.includes(DELIVERY_ACCESSORIALS.LIFTGATE)) {
      appliedAccessorialsList = appliedAccessorialsList.filter(
        (code) => code !== DELIVERY_ACCESSORIALS.LIFTGATE
      );
    }
    if (appliedAccessorialsList.includes(PICKUP_ACCESSORIALS.LIFTGATE)) {
      appliedAccessorialsList = appliedAccessorialsList.filter(
        (code) => code !== PICKUP_ACCESSORIALS.LIFTGATE
      );
    }
  }
  return appliedAccessorialsList;
};

const acceptOnlyNumber = (value) => {
  return value && value.replace(/\D/g, "");
};

const getStopTime = (arrivalTime, departureTime) => {
  if (arrivalTime && departureTime) {
    return getTimeDifferenceInMinutes(departureTime, arrivalTime);
  }
  return null;
};

export {
  getMinutesInHourAndMinutesStr,
  getAccessorialsAfterExclusion,
  acceptOnlyNumber,
  pluralize,
  getStopTime,
};
